import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { TextAreaInterface } from 'common/types/entities/TextAreaInterface'
import React from 'react'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'
import Input from '../components/Input'
import { useUpdateProp } from '../hooks/useUpdateProps'
import HtmlAttrId from '../options/HtmlAttrId'
import Border from '../styles/Border'
import FontSize from '../styles/FontSize'
import ShadowStyle from '../styles/ShadowStyle'

function TextAreaSettings({
  entity,
  defaultEntity,
}: {
  entity: TextAreaInterface
  defaultEntity?: TextAreaInterface
}) {
  const { isMobile } = useDeviceModeContext()
  const updateProp = useUpdateProp(entity)
  return (
    <>
      <Input
        labelText="entity_settings.textarea.placeholder.label"
        value={entity.placeholder}
        update={updateProp('placeholder')}
        placeholder=""
        type="text"
        helpMessage=""
      />
      <ColorPickerControl
        update={updateProp('color')}
        mobileUpdate={updateProp('mobileColor')}
        color={entity.color}
        mobileColor={entity.mobileColor}
      />
      <ColorPickerControl
        label="settings_styles.background_color.label"
        update={updateProp('backgroundColor')}
        mobileUpdate={updateProp('mobileBackgroundColor')}
        color={entity.backgroundColor}
        mobileColor={entity.mobileBackgroundColor}
      />
      <FontSize
        update={updateProp('fontSize')}
        mobileUpdate={updateProp('mobileFontSize')}
        fontSize={entity.fontSize}
        mobileFontSize={entity.mobileFontSize}
      />
      <RangeElement
        label="entity_settings.textarea.height"
        onChange={updateProp('height')}
        value={entity.height}
        max={400}
      />
      <Border
        update={updateProp('border')}
        mobileUpdate={updateProp('mobileBorder')}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
        defaultBorder={defaultEntity?.border}
        mobileDefaultBorder={defaultEntity?.mobileBorder}
      />
      <ShadowStyle
        shadow={entity.boxShadow}
        mobileShadow={entity.mobileBoxShadow}
        update={updateProp('boxShadow')}
        mobileUpdate={updateProp('mobileBoxShadow')}
      />
      <SizeAndPositionGroup
        padding={isMobile ? entity?.mobilePadding : entity.padding}
        defaultPadding={
          isMobile ? defaultEntity?.mobilePadding : defaultEntity?.padding
        }
        updatePadding={updateProp(isMobile ? 'mobilePadding' : 'padding')}
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default TextAreaSettings
